import { render, staticRenderFns } from "./boardGalleryPage.vue?vue&type=template&id=083ff276&scoped=true&"
import script from "./boardGalleryPage.vue?vue&type=script&lang=js&"
export * from "./boardGalleryPage.vue?vue&type=script&lang=js&"
import style0 from "./boardGalleryPage.vue?vue&type=style&index=0&id=083ff276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ff276",
  null
  
)

export default component.exports